export default __webpack_public_path__ + "static/media/cold-galvanizing-icon.6bc6faa0.svg";